/**
 * Returns the number type for given currency
 * For example:
 * ```typescript
 *  currencytoNumber('$1,123') => 1123
 * ```
 */
export const currencytoNumber = (amount: number | string): number =>
  +amount?.toString().replace(/[^0-9.-]+/g, '');
